// extracted by mini-css-extract-plugin
export var actionIcon = "_oh-0";